module.exports = __webpack_public_path__ + "static/media/toni-braxton-he-wasnt-man-enough-by-ryan-ashley-cover.d55e92f5.mp3";